import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController  } from 'ionic-angular';


/**
 * Generated class for the CarteirinhaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-carteirinha',
  templateUrl: 'carteirinha.html',
})
export class CarteirinhaPage {
  usuario: any = {};
  bemVindo: any;
  foto = null;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public loadingCtrl: LoadingController) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad CarteirinhaPage');
    this.usuario = this.navParams.get("usuario");

    this.bemVindo = this.navParams.get("bemvindo");
    if (this.usuario.dados.foto == null) {
      this.usuario.dados.foto = "public/perfildefault.jpg";
    }
    if (this.usuario.dados.foto != null) { 
      this.foto = this.usuario.dados.foto;
    }
  }
  downloadCarterinha(){
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    var iframe = document.querySelector("#iframe-carteirinha");
    iframe.setAttribute('src','https://backend.sistema.sintufrj.org.br/public/api/gerar/carteirinha/'+this.usuario.siape);
    document.getElementById("iframe-carteirinha").click();
    setTimeout(function(){ loading.dismiss(); }, 2000);
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/carteirinha/carteirinha.ts